import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import intl from 'react-intl-universal';
import { togglePartSettleDrawerVisible } from '@/redux/actions/bill/partSettle';
import { toggleTransferModalVisible, initTransferTargets } from '@/redux/actions/bill/transfer';
// import { togglePartRefundDrawerVisible } from '@/redux/actions/bill/partRefund';
// import { toggleReverseDrawerVisible } from '@/redux/actions/bill/reverse';
import AuthBtn from '@/components/AuthBtn';
import { PERM_CODES } from '@/config';

import styles from './index.module.scss';

function BillCtrl(props) {
  const { billList, selectedBills, selectedBillIds } = props;

  const [partSettleDisabled, setPartSettleDisabled] = useState(false);
  const [transferDisabled, setTransferDisabled] = useState(false);
  // const [partRefundDisabled, setPartRefundDisabled] = useState(false);
  // const [reverseDisabled, setReverseDisabled] = useState(false);

  // 判定是否可部分结账
  const judgeCanPartSettle = (bills) => {
    // 至少选择一个项目
    if (bills.length === 0) return false;

    // 账目状态必须是未结
    const isBillStatusMatched = bills.every((bill) => bill.status === 0);

    // 不能包含押金
    const depositMatched = bills.every((bill) => bill.depositFlag !== true);

    // 未勾选的账目至少有一项是未结
    const notSelectedBills = billList.filter((bill) => !selectedBillIds.includes(bill.no));
    const notSelectedBillMatched = notSelectedBills.some((bill) => bill.status === 0);

    return isBillStatusMatched && depositMatched && notSelectedBillMatched;
  };

  // 判定是否可转账
  const judgeCanTransfer = (bills) => {
    // 至少勾选一项
    if (bills.length === 0) return false;

    // 状态必须是未结
    const isBillStatusMatched = bills.every((bill) => bill.status === 0);

    // 勾选的账单必须允许转账（会员卡付款、CRS预付款、直连OTA预付款不可转账）
    const isAllowTransferMathed = bills.every((bill) => bill.transferFlag === true);

    return isBillStatusMatched && isAllowTransferMathed;
  };

  // // 判定是否可部分退款
  // const judgeCanPartRefund = (bills) => {
  //   // 只能勾选一项
  //   // 自动勾选退款账目的情况，排除所勾选的退款账目
  //   // 先过滤自动勾选的退款账目
  //   const realRefundBills = bills.filter((bill) => bill.postType !== 4);
  //   if (realRefundBills.length !== 1) return false;

  //   // 入账类型必须是付款
  //   const isPostTypeMatched = realRefundBills.every((bill) => bill.postType === 1);

  //   // 状态必须是未结
  //   const isBillStatusMatched = realRefundBills.every((bill) => bill.status === 0);

  //   return isPostTypeMatched && isBillStatusMatched;
  // };

  // // 判定是否可冲调
  // const judgeCanReverse = (bills) => {
  //   // 只能勾选一项
  //   // 自动勾选冲调、优惠账目的情况，排除所勾选的冲调、优惠账目
  //   // 先过滤自动勾选的冲调和优惠账目
  //   const realReverseBills = bills.filter((bill) => ![2, 3].includes(bill.postType));
  //   if (realReverseBills.length !== 1) return false;

  //   // 入账类型必须是消费
  //   const isPostTypeMatched = realReverseBills.every((bill) => bill.postType === 0);

  //   // 状态必须是未结
  //   const isBillStatusMatched = realReverseBills.every((bill) => bill.status === 0);

  //   return isPostTypeMatched && isBillStatusMatched;
  // };

  // dynamic button disabled status
  useEffect(() => {
    setPartSettleDisabled(!judgeCanPartSettle(selectedBills));
    setTransferDisabled(!judgeCanTransfer(selectedBills));
    // setPartRefundDisabled(!judgeCanPartRefund(selectedBills));
    // setReverseDisabled(!judgeCanReverse(selectedBills));
  }, [selectedBills]);

  const partSettle = () => {
    props.togglePartSettleDrawerVisible(true);
  };

  const transfer = () => {
    props.toggleTransferModalVisible(true);
    props.initTransferTargets();
  };

  // const partRefund = () => {
  //   props.togglePartRefundDrawerVisible(true);
  // };

  // const reverse = () => {
  //   props.toggleReverseDrawerVisible(true);
  // };

  return (
    <div className={styles['bill-ctrl']}>
      <AuthBtn>
        <span style={{ marginRight: 30 }}>
          {intl.get('bill_selected_count', { value: selectedBills.length })}
        </span>
        <Button
          data-authkey={PERM_CODES.PART_SETTLE}
          disabled={partSettleDisabled}
          onClick={() => partSettle()}
        >
          {intl.get('bill_part_refund_settle_title')}
        </Button>
        <Button
          data-authkey={PERM_CODES.TRANSTER_ACCOUNT}
          disabled={transferDisabled}
          onClick={() => transfer()}
        >
          {intl.get('bill_transfer')}
        </Button>
      </AuthBtn>
      {/* <Divider className={styles['bill-ctrl-devider']} type="vertical" />
      <Button disabled={partRefundDisabled} onClick={() => partRefund()}>
        部分退款
      </Button>
      <Button disabled={reverseDisabled} onClick={() => reverse()}>
        冲调
      </Button> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  const { billList, selectedBills, selectedBillIds } = state.bill;
  return { billList, selectedBills, selectedBillIds };
};

export default connect(mapStateToProps, {
  togglePartSettleDrawerVisible,
  toggleTransferModalVisible,
  initTransferTargets,
  // togglePartRefundDrawerVisible,
  // toggleReverseDrawerVisible,
})(BillCtrl);
